const falsePositiveMessages = [
    'Failed to execute \'removeChild\' on \'Node\': The node to be removed is not a child of this node.',
    'The above error occurred in one of your React components:',
    'An error was thrown inside one of your components, but React doesn\'t know what it was.'
];

export const isFalsePositiveMessage = (message: string) => {
    return falsePositiveMessages.some(m => message.toLowerCase().includes(m.toLowerCase()));
};
